import React, { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: 'none' | 'default';
  hover?: boolean;
  onClick?: () => void;
}

export default function CardComponent({ 
  children, 
  className = '', 
  padding = 'default',
  hover = false,
  onClick 
}: CardProps) {
  const baseStyles = 'bg-white border border-[#E5E7EB] rounded-lg shadow-sm';
  const paddingStyles = padding === 'default' ? 'p-6' : '';
  const hoverStyles = hover ? 'hover:border-[#9CA3AF] hover:shadow-md transition-all cursor-pointer' : '';
  const clickStyles = onClick ? 'cursor-pointer' : '';
  
  return (
    <div 
      className={`${baseStyles} ${paddingStyles} ${hoverStyles} ${clickStyles} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
